import { NgModule, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentModule } from 'angular2-moment';
import { BrowserModule } from '@angular/platform-browser';
import {
    MatTabsModule, MatCheckboxModule, MatDatepickerModule, MatInputModule, MatRadioModule, MatListModule,
    MatSelectModule, MatButtonModule, MatToolbarModule, MatMenuModule, MatSidenavModule, MatIconModule, MatDialogModule, MatCardModule
} from '@angular/material';
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { FormMessageComponent } from '../components/form/message/message.component';
import { FormLabelComponent } from '../components/form/label/label.component';
import { DataTablesModule } from 'angular-datatables';
import { ScheduleModule, CalendarModule, DialogModule, CheckboxModule } from 'primeng/primeng';

@NgModule({
    declarations: [
        FormMessageComponent,
        FormLabelComponent,
        AccordionAnchorDirective,
        AccordionLinkDirective,
        AccordionDirective
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatInputModule,
        MatRadioModule,
        MatSelectModule,
        MatButtonModule,
        MatToolbarModule,
        MatMenuModule,
        MatSidenavModule,
        MatIconModule,
        MatListModule,
        MatTabsModule,
        DataTablesModule,
        ScheduleModule,
        CalendarModule,
        DialogModule,
        CheckboxModule,
        MatDialogModule,
        MatCardModule,
        MomentModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormMessageComponent,
        FormLabelComponent,
        MatCheckboxModule,
        MatDatepickerModule,
        MatInputModule,
        MatRadioModule,
        MatSelectModule,
        MatButtonModule,
        MatToolbarModule,
        MatMenuModule,
        MatSidenavModule,
        MatIconModule,
        MatListModule,
        MatTabsModule,
        MatCardModule,
        AccordionDirective,
        AccordionLinkDirective,
        DataTablesModule,
        ScheduleModule,
        CalendarModule,
        DialogModule,
        CheckboxModule,
        MomentModule
    ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/shared.module.ts